import { computed }               from 'mobx' ;
import { SelectParam }            from 'antd/lib/menu';

import { CTE }                    from '../01_core' ;
import { MApp }                   from '../09_model_app' ;

  
let g_m_screen_main: MScreenMain ;

export class MScreenMain
{
  static instance ( ) : MScreenMain
  {
    if ( !g_m_screen_main )
         g_m_screen_main = new MScreenMain( ) ;

    return g_m_screen_main ;
  }

  @computed get selected_menu ( )
  {
    return MApp( ).cur_page.name ;
  }

  on_select_menu = ( param: SelectParam ) =>
  {
    const app = MApp( ) ;

    app.open_page( { name: param.key as CTE.SCREEN, path: {} } ) ;
  }
}